import {List} from 'immutable'

import {cleanResponse} from '../redux/apiHelper'
import {RESHAPE_PLANS} from '../actions/corpMaxActionTypes'

const plansReducer = (state = List(), action) => {
  switch (action.type) {
    case RESHAPE_PLANS:
      return cleanResponse(action.payload)
    default:
      return state
  }
}

export default plansReducer
